export default __webpack_public_path__ + "static/media/office6full.20ca3e71.jpg";